// src/components/signup/styles/signUpPageStyles.ts
import { SxProps, Theme } from '@mui/material/styles';

export const useSignUpPageStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    width: '100%',
    minHeight: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    background:
      theme.palette.mode === 'dark'
        ? 'radial-gradient(circle at 10% 20%, rgba(30, 64, 175, 0.6), rgba(15, 23, 42, 0.95))'
        : 'radial-gradient(circle at 0% 0%, #ecfeff 0%, #f8fafc 70%)',
    padding: { xs: '4rem 1.5rem', md: '6rem 3rem' },
    boxSizing: 'border-box',
  },
  contentWrapper: {
    width: '100%',
    maxWidth: '1200px',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: '2.5rem', md: '3.5rem' },
  },
  leftSide: {
    flex: 1,
    background:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(135deg, rgba(30, 64, 175, 0.35), rgba(15, 118, 110, 0.35))'
        : 'linear-gradient(135deg, rgba(14, 165, 233, 0.14), rgba(15, 118, 110, 0.18))',
    border:
      theme.palette.mode === 'dark'
        ? '1px solid rgba(148, 163, 184, 0.4)'
        : '1px solid rgba(14, 165, 233, 0.25)',
    borderRadius: '32px',
    padding: { xs: '2.5rem', md: '3rem' },
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 32px 80px rgba(15, 23, 42, 0.65)'
        : '0 28px 80px rgba(15, 118, 110, 0.12)',
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem',
    color: theme.palette.mode === 'dark' ? '#f8fafc' : '#0f172a',
  },
  rightSide: {
    flex: 1,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(15, 23, 42, 0.9)' : '#ffffff',
    borderRadius: '32px',
    padding: { xs: '2.5rem', md: '3rem' },
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 24px 64px rgba(15, 23, 42, 0.45)'
        : '0 28px 80px rgba(15, 118, 110, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
  },
  linkContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '1.25rem',
  },
  highlightsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  highlightItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
});
